module.exports = __webpack_public_path__ + "img/y1.582ef55c.png";